/**
 * 政府数据
 * 
 * @Author: Focci
 * @Date: 2023-08-07 10:23:21
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-07 10:23:21
 */

'use client'

import PropTypes from 'prop-types'
import useLazyComponent from '@hook/useLazyComponent'
import { isArray } from 'lodash-es'
import { formatLang } from '@lib/datetime'
import { Waypoint } from 'react-waypoint'
import { useLocale, useTranslations } from 'next-intl'
import { useCallback, useState } from 'react'
import PropertyItemScoff from '../PropertyItemScoff'
import GovdataBar from './GovdataBar'
import GovItems from './GovItems'
// import AreaDetail from './area'

export default function Govdata({
  data = {},
  area
}) {
  const locale = useLocale()
  const th = useTranslations('house')
  const [enter, setEnter] = useState(false)

  const { Wedget: AreaDetail, getWedget } = useLazyComponent()

  const handleEnter = useCallback(() => {
    setEnter(true)
    area && getWedget(() => import('./area'))
  }, [area, getWedget])
  
  return (
    <PropertyItemScoff 
      title={th('govdata')}
      moduleName={th('govdata')}
      id="module-govdata"
      meta={
        data.update_at && (
          <div className="mt-2">
            <b>{formatLang(data.update_at, th('updateDateOfData'), locale)}</b>
          </div>
        )
      }
    >
      <GovdataBar data={data} />
      <Waypoint onEnter={handleEnter}>
        <div>
          {isArray(data?.data) && data.data.length > 0 && (
            <div className="mt-6 grid grid-cols-2 md:grid-cols-3 gap-4">
              <GovItems data={data?.data} enter={enter} />
            </div>
          )}
          {area && (
            <div className="min-h-[15rem]">
              <AreaDetail data={area} />
            </div>
          )}
        </div>
      </Waypoint>
    </PropertyItemScoff>
  )
}

Govdata.propTypes = {
  data: PropTypes.object,
}
